'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const EMPTY_SET = Immutable.Set();
const defaults = {
  installed: null,
  hubInstallable: null,
  hubUserInstallable: null,
  incompatibleHubInstalls: EMPTY_SET,
  incompatibleHubUserInstalls: EMPTY_SET,
  missingHubScopeGroups: EMPTY_SET,
  missingHubScopes: EMPTY_SET,
  missingHubUserRoles: EMPTY_SET,
  missingHubUserScopes: EMPTY_SET,
  missingNonTrialHubScopeGroups: EMPTY_SET,
  missingNonTrialHubScopes: EMPTY_SET,
  missingNonTrialHubUserRoles: EMPTY_SET,
  missingNonTrialHubUserScopes: EMPTY_SET,
  nonTrialHubInstallable: null,
  nonTrialHubUserInstallable: null
};

class AppInstallability extends Immutable.Record(defaults) {
  constructor(json = {}) {
    Object.keys(json).forEach(key => {
      const value = json[key];
      const defaultValue = defaults[key];

      if (Immutable.Set.isSet(defaultValue)) {
        json[key] = Immutable.Set(value);
      }
    });
    super(cleanObject(json));
  }

}

export default AppInstallability;